module.exports = __webpack_public_path__ + "img/2025-01-09a_2.3374eb4a.jpg";